import { useTradeIDQueryParams } from 'api';

const buildTitleFromParams = (params: ReturnType<typeof useTradeIDQueryParams>): string => {
  const titles: string[] = [];

  if (params.companyId) titles.push(`Company ${params.companyName} (#${params.companyId})`);
  if (params.dealId) titles.push(`Deal ${params.dealId}`);
  if (params.inspectionId) titles.push(`Inspection ${params.inspectionId}`);
  if (params.loadName) titles.push(`Load ${params.loadName}`);
  if (params.purchaseOrderSlug) titles.push(`Purchase Order ${params.purchaseOrderSlug}`);
  if (params.salesOrderSlug) titles.push(`Sales Order ${params.salesOrderSlug}`);
  if (params.shipmentName) titles.push(`Shipment ${params.shipmentName}`);
  if (titles.length > 0) {
    return `Create a Support Issue for ${titles.join(', ')}`;
  }
  return 'Create a Support Issue';
};

export const useSupportIssueTitle = (): string => {
  const queryParams = useTradeIDQueryParams();
  return buildTitleFromParams(queryParams);
};
